// Import React library to create the component
import React from 'react';
// Import FontAwesomeIcon component for rendering brand icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Import specific brand icons for Facebook, Instagram, and YouTube
import { faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

// Footer component definition
const Footer = () => {
  return (
    // Footer container with background color, font, padding, and margin-top
    <footer className="bg-gray-900 text-base font-sans py-10 px-4 mt-5">
      
      {/* Grid container for the four columns in the footer */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 py-4">

        {/* Column 1: What We Offer */}
        <div>
          {/* Section heading */}
          <h5 className="text-white font-semibold mb-2">What We Offer</h5>
          {/* Description text in gray, smaller font */}
          <p className="text-gray-300 text-sm">
            To keep you up to date, we curate a collection of news & infos from reliable sources within Newstarn.
          </p>
        </div>

        {/* Column 2: Useful Links */}
        <div>
          {/* Section heading */}
          <h5 className="text-white font-semibold mb-2">Useful Links</h5>
          {/* List of navigational links with spacing between items */}
          <ul className="space-y-1">
            <li>
              {/* Home link with hover color change and smooth transition */}
              <a href="/" className="text-gray-300 hover:text-gray-400 transition">Home</a>
            </li>
            <li>
              {/* Advertise page link */}
              <a href="/advertise" className="text-gray-300 hover:text-gray-400 transition">Advertise With Us</a>
            </li>
            <li>
              {/* Contact page link */}
              <a href="/contactus" className="text-gray-300 hover:text-gray-400 transition">Contact Us</a>
            </li>
            <li>
              {/* Privacy Policy page link */}
              <a href="/privacypolicy" className="text-gray-300 hover:text-gray-400 transition">Privacy Policy</a>
            </li>
            <li>
              <a href="https://store.newstarn.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gray-400 transition">Store</a>
            </li>
          </ul>
        </div>

        {/* Column 3: Sources */}
        <div>
          {/* Section heading */}
          <h5 className="text-white font-semibold mb-2">Sources</h5>
          {/* List of news sources with small gray text */}
          <ul className="space-y-1 text-sm text-gray-300">
            <li>ChannelsTV</li>
            <li>FoxNews</li>
            <li>Vanguardngr</li>
            <li>Dailytrust</li>
          </ul>
        </div>

        {/* Column 4: Social Links */}
        <div>
          {/* Section heading */}
          <h5 className="text-white font-semibold mb-2">Follow Us</h5>
          {/* Flex container to arrange social icons with spacing */}
          <div className="flex gap-4 mt-2">
            {/* Facebook link opens in a new tab and prevents security issues with rel */}
            <a href="https://facebook.com/people/Newstarn/61574926899598/" target="_blank" rel="noopener noreferrer">
              {/* Render Facebook icon with hover effect and size 2x */}
              <FontAwesomeIcon icon={faFacebook} className="text-gray-300 hover:text-gray-400 transition" size="2x" />
            </a>
            {/* Instagram link */}
            <a href="https://instagram.com/newstarnz/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} className="text-gray-300 hover:text-gray-400 transition" size="2x" />
            </a>
            {/* YouTube link with subscription confirmation */}
            <a href="https://youtube.com/channel/UCmFWjs94o7yOrFYwwlT2geQ?sub_confirmation=1" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutube} className="text-gray-300 hover:text-gray-400 transition" size="2x" />
            </a>
          </div>
        </div>
      </div>

      {/* Horizontal line separating main content from copyright */}
      <hr className="my-6 border-gray-700" />

      {/* Bottom footer text: site name and copyright */}
      <div className="text-center text-gray-400 text-sm">
        {/* Link to homepage with hover effect */}
        <a href="/" className="text-gray-300 hover:text-gray-400 transition">Newstarn</a> &copy; {new Date().getFullYear()} | All rights reserved
      </div>
    </footer>
  );
};

// Export Footer component for use in other parts of the app
export default Footer;
